import React, { useRef, useEffect, useState, TextareaHTMLAttributes } from 'react';
import styled from 'styled-components';

interface AutoHeightTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder: string;
  required?: boolean;
}

const Container = styled.div`
  position: relative;
  font-family: inherit;
  font-size: inherit;
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  overflow: hidden;
  padding: 8px;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.5;
  white-space: pre-wrap;
  color: rgba(57, 29, 10, 1);
  background: none;
  min-height: calc(1.5em * 10);
`;

interface PlaceholderLabelProps {
  isHidden: boolean;
  required?: boolean;
}
const PlaceholderLabel = styled.label<PlaceholderLabelProps>`
  position: absolute;
  top: 8px;
  left: 8px;
  color: rgba(137, 121, 110, 1);
  pointer-events: none;
  transition: opacity 0.3s ease;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};

  &:after {
    content: ${({ required }) => (required ? "' *'" : "''")};
    color: red;
  }
`;

const AutoHeightTextarea: React.FC<AutoHeightTextareaProps> = ({
                                                                 placeholder,
                                                                 required,
                                                                 onChange,
                                                                 ...props
                                                               }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState(props.value ? String(props.value) : '');

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    adjustHeight();
    onChange && onChange(e);
  };

  return (
    <Container>
      <StyledTextarea
        {...props}
        ref={textareaRef}
        value={value}
        onChange={handleChange}
        placeholder=""
      />
      <PlaceholderLabel isHidden={value.length > 0} required={required}>
        {placeholder}
      </PlaceholderLabel>
    </Container>
  );
};

export default AutoHeightTextarea;
